import PresetList from './PresetList';
import PresetEdit from './PresetEdit';
import PresetCreate from './PresetCreate';
import PresetIcon from '@material-ui/icons/LibraryBooks';

export default {
  list: PresetList,
  edit: PresetEdit,
  create: PresetCreate,
  icon: PresetIcon
};
